// Module
var code = " <style ng-bind=\"$ctrl.getProjector().custom_css\"></style> <gb-styles></gb-styles> <gb-presenter ng-if=\"!$ctrl.syncingInitial && !$ctrl.hasError()\"></gb-presenter> <gb-presenter-error ng-if=\"!$ctrl.isLoading() && $ctrl.hasError()\"></gb-presenter-error> <gb-loader-overlay></gb-loader-overlay> ";
// Exports
export default code;